import React from 'react'
import injectSheet from 'react-jss'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import BigCalendar from 'react-big-calendar';
import moment from 'moment';


const styles = {
  root: {
    height: '450px',
    maxWidth: '1170px',
    background: 'white',
    margin: '2% auto 0',
    padding: '40px'
  },
  calendar: {
    border: '1px solid rgba(220, 220, 220, 0.9)',
    borderRadius: '4px',
    width: '100%'
  },
  currentCity: {
    textTransform: 'capitalize',
    textAlign: 'center',
    fontSize: '20px',
    margin: '-30px 0 10px',
  },

}

BigCalendar.momentLocalizer(moment);


class SeeEventsPage extends React.Component {
  render() {
    const { classes, gotoUrl, setEvent, currentCity } = this.props
    const events = this.props.events || []

    return(
      <div>
        <div className={classes.root}>
          <div>{currentCity ? <div className={classes.currentCity}>{currentCity}</div> : null}</div>
          <BigCalendar
            className={classes.calendar}
            events={
              events.map((eventName) =>{
                const eventTime = new Date(moment(eventName.start).add(eventName.utc_offset, 'seconds'))
                return {
                  title: eventName.name,
                  start: eventTime,
                  end: eventTime,
                  description: eventName.description,
                  venue: eventName.venue,
                  address: eventName.address,
                  url: eventName.url,
                  photo_url: eventName.photo_url,
                  eventStart: eventName.start,
                  utc_offset: eventName.utc_offset
                }
              })
            }
            onSelectEvent = {
              (event) => {
                setEvent(event)
              }
            }
          />
        </div>
      </div>
      )
  }
}


export default injectSheet(styles)(SeeEventsPage)



// WEBPACK FOOTER //
// ./src/components/SeeEventsPage.jsx